import React from 'react'
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'

import { msalInstance } from '../../msalClient'
import { loginRequest } from '../../config/msalConfig'
import Button from '../Button/Button'

import './AuthenticateUser.scss'

const authenticateUser = props => {
  const handleLogin = () => msalInstance.loginRedirect(loginRequest())

  if (props.isPartnerAgent) {
    return (
      <>
        <AuthenticatedTemplate>{props.children}</AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <div className="appLogin">
            <div className="login">
              <div className="transaviaLogo" />
              <p>{props.labels['Login Message']}</p>
              <Button
                type="primary"
                align="center"
                data-element="confirm-login"
                onClick={() => handleLogin()}
              >
                {props.labels['Login Button']}
              </Button>
            </div>
          </div>
        </UnauthenticatedTemplate>
      </>
    )
  } else {
    return props.children
  }
}

export default authenticateUser
